import { useEffect } from 'react';
import { getBapiService } from '../../../../../api_services/BapiService';
import { useAppStore } from '../../../../../store/appStore';

export const useLoadGcpRequest = () => {
  const { selectedMission, getGcpRequest, setGcpRequest } = useAppStore();

  const customerId = selectedMission?.customer.id;
  const siteId = selectedMission?.site.id;

  useEffect(() => {
    if (!customerId || !siteId) return;

    const gcpRequest = getGcpRequest(customerId, siteId);

    if (!gcpRequest && gcpRequest !== null) {
      (async () => {
        const result = await getBapiService().getCurrentGcpRequest(customerId, siteId);
        setGcpRequest(customerId, siteId, result[0] ?? null);
      })();
    }
  }, [customerId, siteId]);
};
